import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  CircularProgress,
  Box,
  Container,
  Paper,
  Stepper,
  StepLabel,
  Step,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import React, { useEffect, useRef, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import {
  useGetCustomerOrdersMutation,
  useGetTransactionTokenMutation,
  useAddTransactionHistoryMutation,
} from "../../../redux/reducer/features/Customer/CustomerSlice";
import ServerAppGrid from "../../app/ServerAppGrid";
import { AppFilter } from "../../../models/app/AppModels";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ErrorMessage, Form, Formik, FormikProps } from "formik";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import PageLoader from "../../app/PageLoader";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import {
  addPortalSettings,
  useAddPayPalTransactionHistoryMutation,
  useGetPayPalClientIdMutation,
  useGetPortalSettingMutation,
} from "../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { Dispatch } from "@reduxjs/toolkit";
import {
  CustomerCheckoutDetail,
  CustomerCheckoutInitialValues,
  CustomerCheckoutValidationSchema,
} from "./../../../models/features/Customer/CustomerCheckoutDetail";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import { CheckoutDetail } from "../../../models/features/Gravity/CheckoutDetail";

declare const emergepay: any;

interface OrderGridProps {
  orderType: string;
  handlePayButton: any;
  openCheckout: boolean;
  handleCloseCheckout: any;
}
const OrderGrid: React.FunctionComponent<OrderGridProps> = (props) => {
  const dispatch = useDispatch<Dispatch<any>>();
  const { portalSettings, expiryTime } = useSelector(
    (state: AppState) => state.shoppingPortalReducer
  );
  const currentTime = Date.now();
  const [getPortalSettingMutation, getPortalSettingMutationResult] =
    useGetPortalSettingMutation();
  const orderInvoiceDiv = React.useRef<HTMLImageElement>(null);
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const [getOrderMutation, getOrderMutationResult] =
    useGetCustomerOrdersMutation();
  const [getTransactionTokenMutation, getTransactionTokenMutationResult] =
    useGetTransactionTokenMutation();
  const [addTransactionHistoryMutation, addTransactionHistoryMutationResult] =
    useAddTransactionHistoryMutation();
  const { everestDmsDealerId, setupId, userType, dmsSetup, customerData } =
    useSelector((state: AppState) => state.authReducer);
  const partsPortalDmsdealerId = useSelector(
    (state: AppState) => state.shoppingPortalReducer.portalSettings?.dmsDealerId
  );
  const paymentMethod = useSelector(
    (state: AppState) => state.shoppingPortalReducer.portalSettings?.paymentType
  );
  const [customerCheckoutDetail, setCustomerCheckoutDetail] =
    React.useState<any>(CustomerCheckoutInitialValues);
  const [getClientIdMutation, getClientIdMutationResult] =
    useGetPayPalClientIdMutation();
  const [
    addPayPalTransactionHistoryMutation,
    addPayPalTransactionHistoryMutationResult,
  ] = useAddPayPalTransactionHistoryMutation();
  const [orders, setOrders] = useState<any[]>([]);
  const [generatingPdf, setGeneratingPdf] = useState(false);
  const [storeDetails, setStoreDetails] = useState({ name: "", address: "" });
  const [customerAddress, setCustomerAddress] = useState("");
  const [orderInvoicePart, setOrderInvoicePart] = useState<any>("");
  const [openInvoicePart, setOpenInvoicePart] = useState(false);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [openCheckout, setOpenCheckout] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [amountToPay, setAmountToPay] = React.useState("");
  const [transactionReference, setTransactionReference] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [selectedOrders, setSelectedOrders] = React.useState<any>([]);

  const [customerInformation, setCustomerInformation] =
    React.useState<CustomerCheckoutDetail>();
  const [clinetId, setClientId] = useState("");

  const formRef = useRef<FormikProps<CustomerCheckoutDetail>>(null);
  const steps = ["Shipping address", "Invoice details"];
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  useEffect(() => {
    if (selectedRows.length > 0) {
      props.handlePayButton(true);
    } else {
      props.handlePayButton(false);
    }
    let selectedData = orders.filter((order) =>
      selectedRows.includes(order.orderId)
    );
    setSelectedOrders(selectedData);
  }, [selectedRows]);

  useEffect(() => {
    if (selectedOrders.length > 0) {
      const totalPayment = selectedOrders.reduce((total: any, order: any) => {
        return total + order.payment;
      }, 0);
      setAmountToPay(totalPayment);
    }
  }, [selectedOrders]);

  useEffect(() => {
    if (portalSettings === undefined || currentTime > expiryTime) {
      getPortalSettingMutation({ storeUrl: dmsSetup?.shopifyUrl ?? "" });
    }
  }, [portalSettings]);
  useEffect(() => {
    if (
      getPortalSettingMutationResult.data &&
      getPortalSettingMutationResult.isSuccess
    ) {
      if (getPortalSettingMutationResult.data.status === 200) {
        if (getPortalSettingMutationResult.data.entity) {
          const expiryTime = currentTime + 60 * 60 * 1000;
          dispatch(
            addPortalSettings({
              settings: getPortalSettingMutationResult.data.entity,
              storeUrl: dmsSetup?.shopifyUrl ?? "",
              logoUrl: "",
              expiryTime: expiryTime,
            })
          );
        }
      } else {
      }
    }
  }, [getPortalSettingMutationResult]);

  const handleOnSubmit = (values: CheckoutDetail) => {
    setErrorMessage("");
    values.transactionReference = "";
    values.amount = amountToPay;
    values.cashierId = values.billingName;
    values.dmsSetupId = setupId;
    getTransactionTokenMutation({ data: values });
  };

  const handleSubmitCustomerInfo = async (values: CustomerCheckoutDetail) => {
    setCustomerInformation(values);
    if (paymentMethod === "PayPal") {
      handleGetClientId();
    }

    handleNext();
  };
  const handleGetClientId = () => {
    getClientIdMutation({ setupId: setupId }).then((response: any) => {
      if (response && response.data) {
        setClientId(response.data.entity);
      }
    });
  };
  const InititatePayment = (transactionToken: string) => {
    emergepay.open({
      transactionToken: transactionToken,
      onTransactionSuccess: (approvalData: any) => {
        setIsLoading(false);
        (window as any).emergepay.close();
        var histories = selectedOrders.map((order: any) => ({
          targetCustomerId: customerData?.customerId,
          orderId: order.orderId,
          ...approvalData,
        }));

        addTransactionHistoryMutation({ data: histories });
        setOrders(
          orders.map((item: any) =>
            selectedRows.includes(item.orderId) ? { ...item, payment: 0 } : item
          )
        );
        setSelectedRows([]);
        handleClose();
      },
      onTransactionFailure: (failureData: any) => {
        setIsLoading(false);
      },
      onTransactionCancel: () => {
        setIsLoading(false);
      },
    });
  };

  const handleClose = () => {
    setActiveStep(0);
    setErrorMessage("");
    setOpenInvoicePart(false);
    setOpenCheckout(false);
    props.handleCloseCheckout();
  };
  const handleClick = (item: any) => {
    setOrderInvoicePart(item);
    setOpenInvoicePart(true);
    const details = getStoreDetails(item.dealerId);
    setStoreDetails(details);
  };

  const generateOrderInvoicePdf = async () => {
    setGeneratingPdf(true);
    const options = {
      scale: 2,
      width: 1000,
    };
    const htmlElement = orderInvoiceDiv.current as HTMLElement;
    const canvas = await html2canvas(htmlElement, options);
    var imgData = canvas.toDataURL("image/png");
    var doc = new jsPDF({ orientation: "portrait", compress: true });
    const imgProps = doc.getImageProperties(imgData);
    const pdfWidth = doc.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight, "FAST");
    doc.save("Invoice.pdf");
    setGeneratingPdf(false);
  };

  const getStoreDetails = (dealerId: any) => {
    var store = dmsSetup?.dmsLocations.find((loc) => loc.dealerId === dealerId);
    var address =
      (store?.address ?? "") +
      " " +
      (store?.city ?? "") +
      " " +
      (store?.stateOrProvince ?? "") +
      " " +
      (store?.zipPostal ?? "");

    return {
      name: store?.name ?? "",
      address: address,
    };
  };

  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US");
  };
  useEffect(() => {
    var data =
      customerData?.address && customerData?.address.length > 0
        ? customerData?.address[1]
        : {};

    var address =
      (data?.address1 ?? "") +
      " " +
      (data?.city ?? "") +
      " " +
      (data?.stateOrProvince ?? "") +
      " " +
      (data?.zipPostal ?? "");

    setCustomerAddress(address);
  }, [customerData]);

  useEffect(() => {
    if (customerData && customerData.email) {
      setCustomerCheckoutDetail({
        ...customerCheckoutDetail,
        billingName: customerData.organizationName ?? "",
        email:
          customerData.email.length > 0 ? customerData?.email[0]?.address : "",
        phone: customerData?.phone ?? "",
      });
    }
  }, [customerData]);

  React.useEffect(() => {
    fetchData();
  }, [paging.pageSize, props.orderType, paging.pageIndex]);

  const fetchData = () => {
    if (userType === "Customer") {
      getOrderMutation({
        customerId: customerData?.customerId?.toString(),
        everestDmsDealerId: everestDmsDealerId ?? "",
        paging: paging,
        orderType: props.orderType,
      });
    } else if (userType === "PortalCustomer") {
      getOrderMutation({
        email: customerData?.email,
        everestDmsDealerId: partsPortalDmsdealerId?.toString() ?? "",
        paging: paging,
        orderType: props.orderType,
      });
    }
  };

  React.useEffect(() => {
    if (getOrderMutationResult.data && getOrderMutationResult.isSuccess) {
      setOrders(
        getOrderMutationResult.data?.entityList?.map(
          (item: any, index: number) => ({
            id: index,
            payment: index % 2 === 0 ? 10 : item.payment,
            ...item,
          })
        )
      );
      setTotalRecords(getOrderMutationResult.data.totalRecords ?? 0);
    }
  }, [getOrderMutationResult]);

  React.useEffect(() => {
    if (
      getTransactionTokenMutationResult.data &&
      getTransactionTokenMutationResult.isSuccess
    ) {
      if (
        getTransactionTokenMutationResult.data &&
        getTransactionTokenMutationResult.data.status === 0
      ) {
        if (
          getTransactionTokenMutationResult.data.entity.transactionToken !==
          null
        ) {
          setIsLoading(true);
          setOpenCheckout(false);
          InititatePayment(
            getTransactionTokenMutationResult.data.entity.transactionToken
          );
        } else {
          setErrorMessage("Sorry, We're not able to start your payment");
        }
      } else {
        setErrorMessage("Sorry, We're not able to start your payment");
      }
    }
  }, [getTransactionTokenMutationResult]);

  const compIsType = (t: any, s: any) => {
    for (let z = 0; z < t.length; ++z) if (t[z] === s) return true;

    return false;
  };
  const handlePlaceChanged = (place: any) => {
    let placeId = "";
    let country,
      countryCode,
      postalCode,
      street_number,
      route_number,
      state,
      city = "";

    let formattedAddress = "";

    if (place.address_components) {
      formattedAddress = [
        (place.address_components[0] &&
          place.address_components[0].short_name) ||
          "",
        (place.address_components[1] &&
          place.address_components[1].long_name) ||
          "",
      ].join(" ");
    }

    if (place.address_components !== undefined) {
      let addrComp = place.address_components;

      placeId = place.place_id;

      for (let i = 0; i < addrComp.length; ++i) {
        var typ = addrComp[i].types;

        if (compIsType(typ, "administrative_area_level_1")) {
          state = addrComp[i].short_name || "";
        }

        if (compIsType(typ, "locality")) {
          city = addrComp[i].long_name || "";
        }

        if (compIsType(typ, "country")) {
          countryCode = addrComp[i].short_name || "";

          country = addrComp[i].long_name || "";
        }

        if (compIsType(typ, "street_number")) {
          street_number = addrComp[i].long_name || "";
        }

        if (compIsType(typ, "route")) {
          route_number = addrComp[i].long_name || "";
        }

        let postalCodeOBj = addrComp.find((ac: any) =>
          ac.types.includes("postal_code")
        );

        postalCode = postalCodeOBj?.short_name;

        if (state != null && city != null && country != null) break;
      }

      return {
        state,
        city,
        countryCode,
        country,
        postalCode,
        placeId,
        formattedAddress,
      };
    }
  };
  const handleSelect = async (address: any) => {
    let resp = await getAddressForAutoFill(address);
    formRef.current?.setFieldValue("address", resp?.formattedAddress || "");
    formRef.current?.setFieldValue("zip", resp?.pin || "");
    formRef.current?.setFieldValue("country", resp?.country || "");
    formRef.current?.setFieldValue("state", resp?.state || "");
    formRef.current?.setFieldValue("city", resp?.city || "");
    if (resp?.country) {
      formRef.current?.setFieldTouched("country", false);
    }
    if (resp?.pin) {
      formRef.current?.setFieldTouched("zip", false);
    }
    if (resp?.state) {
      formRef.current?.setFieldTouched("state", false);
    }
    if (resp?.city) {
      formRef.current?.setFieldTouched("city", false);
    }
  };
  const getAddressForAutoFill = async (address: any) => {
    let returnData = {
      formattedAddress: "",
      pin: "",
      country: "",
      countryCode: "",
      city: "",
      state: "",
      placeId: "",
    };

    let resData = geocodeByAddress(address)
      .then((results) => {
        var addressDetails = results[0];
        let data = handlePlaceChanged(addressDetails);
        returnData.city = data?.city ?? "";
        returnData.state = data?.state ?? "";
        returnData.country = data?.country ?? "";
        returnData.countryCode = data?.countryCode ?? "";
        returnData.pin = data?.postalCode;
        returnData.placeId = data?.placeId ?? "";
        returnData.formattedAddress = data?.formattedAddress ?? "";
        return returnData;
      })
      .catch((error) => {});
    return resData;
  };
  const renderFunc = ({
    getInputProps,
    suggestions,
    getSuggestionItemProps,
    loading,
  }: any) => (
    <>
      <div>
        <TextField
          {...getInputProps()}
          name="address"
          type="text"
          label="Address"
          fullWidth
          variant="standard"
          id="address-input"
        />
        <div className="autocomplete-container">
          <div className="autocomplete-dropdown">
            {loading && <div>Loading...</div>}
            {suggestions.map((suggestion: any) => (
              <>
                <Divider sx={{ width: "100%" }} />
                <div
                  key={suggestion.description}
                  {...getSuggestionItemProps(suggestion)}
                >
                  <span onChange={handleSelect} style={{ cursor: "pointer" }}>
                    {suggestion.description}
                  </span>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );

  function PayPal() {
    const createOrder = (data: any, actions: any) => {
      return actions.order.create({
        purchase_units: [
          {
            amount: {
              value: amountToPay,
            },
          },
        ],
      });
    };
    const onApprove = (data: any, actions: any) => {
      return actions.order.capture().then(function (details: any) {
        if (details.status === "COMPLETED") {
          var histories = selectedOrders.map((order: any) => ({
            targetCustomerId: customerData?.customerId,
            orderId: order.orderId,
            ...details,
          }));
          addPayPalTransactionHistoryMutation({ data: histories })
            .then((res: any) => {
              setOrders(
                orders.map((item: any) =>
                  selectedRows.includes(item.orderId)
                    ? { ...item, payment: 0 }
                    : item
                )
              );
              setSelectedRows([]);
              handleClose();
              handleBack();
            })
            .catch((err) => {
              setErrorMessage("sorry!, we could not complete your payment");
            });
        }
      });
    };

    return (
      <PayPalScriptProvider
        options={{
          clientId: clinetId,
        }}
      >
        <PayPalButtons
          style={{ layout: "horizontal", label: "pay" }}
          fundingSource="paypal"
          createOrder={createOrder}
          onApprove={onApprove}
        />
      </PayPalScriptProvider>
    );
  }

  const columns: GridColDef[] = [
    {
      field: "orderId",
      headerName: "Order Id",
      width: 150,
      editable: false,
    },
    {
      field: "invoiceId",
      headerName: "Invoice Id",
      width: 180,
      editable: false,
    },

    {
      field: "invoiceDate",
      headerName: "Invoice Date",
      width: 220,
      editable: false,
      renderCell: (params: GridRenderCellParams) => {
        return formatDate(params.row.invoiceDate);
      },
    },
    {
      field: "isWarranty",
      headerName: "Warranty",
      width: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams) => {
        return getWarrantyChip(params.row.isWarranty);
      },
    },
    {
      field: "orderStatus",
      headerName: "Status",
      width: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams) => {
        return getStatusChip(params.row.orderStatus);
      },
    },
    {
      field: "actions",
      headerName: "Invoice",
      type: "actions",
      width: 160,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <IconButton
              size="small"
              id="basic-button"
              onClick={(e) => {
                handleClick(params.row);
              }}
            >
              <VisibilityIcon />
            </IconButton>
          </>
        );
      },
    },
    {
      field: "payment",
      headerName: "Payment",
      type: "actions",
      width: 160,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            {params.row?.payment && params.row.payment > 0 ? (
              <Button
                sx={{ fontSize: "0.7125rem" }}
                size="small"
                variant="contained"
                color="warning"
                disabled={setupId ? false : true}
                onClick={() => {
                  //setSelectedOrders([params.row]);
                  setSelectedRows([params.row.orderId]);
                  setOpenCheckout(true);
                }}
              >
                Pay ${params.row.payment.toFixed(2)}
              </Button>
            ) : (
              <Chip label="Paid" color="success" size="small" />
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <PageLoader isLoading={isLoading}></PageLoader>
      <ServerAppGrid
        data={orders ?? {}}
        columns={columns}
        height={566}
        isLoading={getOrderMutationResult.isLoading}
        paging={paging}
        setPaging={setPaging}
        getRowId={(row) => row.orderId}
        totalRecords={totalRecords}
        keepNonExistentRowsSelected={false}
        selectedRows={selectedRows}
        onSelect={(newSelection: any) => {
          setSelectedRows(newSelection);
        }}
        hidePaginator
        disableSelection={true}
      ></ServerAppGrid>
      <Dialog open={openInvoicePart} onClose={handleClose} maxWidth="xl">
        <DialogTitle
          sx={{
            padding: 0,
            paddingLeft: "20px",
            paddingRight: "15px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box display="flex" alignItems="center">
            <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
              Invoice
            </Typography>
            <IconButton
              sx={{ marginLeft: 1 }}
              disabled={generatingPdf}
              size="small"
              id="basic-button"
              onClick={generateOrderInvoicePdf}
            >
              {generatingPdf ? (
                <CircularProgress size="1.2rem" color="inherit" />
              ) : (
                <DownloadIcon />
              )}
            </IconButton>
          </Box>
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Container
            ref={orderInvoiceDiv}
            component="main"
            sx={{ width: "1000px", mt: 1 }}
          >
            <Paper elevation={4}>
              <Box p={3}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography>
                    {formatDate(orderInvoicePart.invoiceDate)}
                  </Typography>
                  <Typography fontSize="14px" align="center">
                    <p
                      style={{
                        fontSize: "18px",
                        margin: 0,
                        fontWeight: "bolder",
                        marginBottom: 5,
                      }}
                    >
                      {storeDetails.name}
                    </p>{" "}
                    {storeDetails.address}
                  </Typography>
                  <Typography>
                    Invoice # {orderInvoicePart.invoiceNumber}
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="body1">
                    <strong>Customer:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {customerData?.organizationName}
                    <br />
                    {customerAddress}
                  </Typography>
                </Box>

                <TableContainer component={Paper} sx={{ mt: 2 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Code</TableCell>
                        <TableCell>Part Number</TableCell>
                        <TableCell align="right">Price($)</TableCell>
                        <TableCell align="right">Quantity Sold</TableCell>
                        <TableCell align="left">Description</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {orderInvoicePart?.invoicePart &&
                      orderInvoicePart?.invoicePart.length > 0 ? (
                        orderInvoicePart?.invoicePart.map((row: any) => (
                          <TableRow
                            sx={{
                              "& > *": { borderBottom: "unset" },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {row.code}
                            </TableCell>
                            <TableCell>{row.partNumber}</TableCell>
                            <TableCell align="right">
                              {row.price.toFixed(2)}
                            </TableCell>
                            <TableCell align="right">
                              {row.quantitySold}
                            </TableCell>
                            <TableCell align="left">
                              {row.description}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell sx={{ textAlign: "center" }} colSpan={5}>
                            No Rows to Show
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  flexDirection="column"
                  alignItems="flex-end"
                >
                  {/* Totals */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    mt={2}
                    gap={3}
                  >
                    <Typography variant="body1">Sub Total:</Typography>
                    <Typography variant="body1">
                      $ {orderInvoicePart?.payment}
                    </Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" gap={3}>
                    <Typography variant="body1">Tax:</Typography>
                    <Typography variant="body1">
                      $ {orderInvoicePart?.tax}
                    </Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" gap={3}>
                    <Typography variant="h6">Total:</Typography>
                    <Typography variant="h6">
                      ${orderInvoicePart?.tax + orderInvoicePart?.payment}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Container>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openCheckout || props.openCheckout}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 1,
            paddingBottom: 0,
          }}
        >
          <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
            Checkout Detail
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Formik
          innerRef={formRef}
          initialValues={customerCheckoutDetail}
          enableReinitialize
          validationSchema={CustomerCheckoutValidationSchema}
          onSubmit={(values) => {
            handleSubmitCustomerInfo(values);
          }}
        >
          {({ values, errors, handleChange, handleBlur, setFieldValue }) => (
            <>
              <Form>
                <DialogContent sx={{ paddingTop: 0, paddingBottom: 0 }}>
                  <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
                    {steps.map((label, index: number) => (
                      <Step key={index}>
                        <StepLabel>{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                  {activeStep === 0 ? (
                    <Grid container spacing={3} p={2}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="billingName"
                          name="billingName"
                          label="Name"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.billingName}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="billingName"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="email"
                          name="email"
                          label="Email"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="email"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="phone"
                          name="phone"
                          label="Phone"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phone}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="phone"
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <PlacesAutocomplete
                          searchOptions={searchOptions}
                          value={values.address}
                          onChange={(ev: any) => {
                            setFieldValue("address", ev);
                          }}
                          onSelect={handleSelect}
                        >
                          {renderFunc}
                        </PlacesAutocomplete>
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="address"
                        />
                      </Grid>

                      <Grid item xs={3}>
                        <TextField
                          id="city"
                          name="city"
                          label="City"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.city}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="city"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          id="state"
                          name="state"
                          label="State"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.state}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="state"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          id="country"
                          name="country"
                          label="Country"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.country}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="country"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          id="zip"
                          name="zip"
                          label="Zip/Postal"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.zip}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="zip"
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <>
                      <Typography variant="h6" gutterBottom>
                        Payment summary
                      </Typography>
                      <TableContainer component={Paper} sx={{ mt: 2 }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Sr.No</TableCell>
                              <TableCell>Order Id</TableCell>
                              <TableCell>Invoice Id</TableCell>
                              <TableCell align="right">Amount($)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {selectedOrders && selectedOrders.length > 0 ? (
                              selectedOrders.map((row: any, index: number) => (
                                <TableRow
                                  sx={{
                                    "& > *": { borderBottom: "unset" },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell component="th" scope="row">
                                    {row.orderId}
                                  </TableCell>
                                  <TableCell>{row.invoiceId}</TableCell>
                                  <TableCell align="right">
                                    {row.payment.toFixed(2)}
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell
                                  sx={{ textAlign: "center" }}
                                  colSpan={4}
                                >
                                  No Rows to Show
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <Box display="flex" justifyContent="flex-end" gap={3}>
                        <Typography variant="h6">Total:</Typography>
                        <Typography variant="h6">${amountToPay}</Typography>
                      </Box>

                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                            Customer Detail
                          </Typography>
                          <Typography gutterBottom>
                            {values.billingName}
                          </Typography>
                          <Typography gutterBottom>{values.phone}</Typography>
                          <Typography gutterBottom>{values.email}</Typography>
                          <Typography gutterBottom>
                            {values.address +
                              ", " +
                              values.city +
                              ", " +
                              values.state +
                              ", " +
                              values.zip +
                              ", " +
                              values.country}
                          </Typography>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </DialogContent>

                <DialogActions
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 1,
                    p: 2,
                  }}
                >
                  {activeStep !== 0 ? (
                    <Button
                      onClick={handleBack}
                      color="primary"
                      variant="contained"
                    >
                      Back
                    </Button>
                  ) : (
                    <Button
                      autoFocus
                      variant="contained"
                      color="error"
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  )}
                  <Typography color="error">{errorMessage}</Typography>
                  {activeStep === steps.length - 1 ? (
                    paymentMethod === "PayPal" ? (
                      getClientIdMutationResult.isLoading ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        <PayPal />
                      )
                    ) : (
                      <Button
                        variant="contained"
                        color="success"
                        disabled={getTransactionTokenMutationResult.isLoading}
                        startIcon={
                          getTransactionTokenMutationResult.isLoading ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            ""
                          )
                        }
                        onClick={() => {
                          let data: CheckoutDetail = {
                            billingName: values.billingName,
                            billingAddress:
                              values.address +
                              ", " +
                              values.city +
                              ", " +
                              values.state +
                              ", " +
                              values.country +
                              "," +
                              values.zip,
                            billingPostalCode: values.zip,
                            amount: "",
                            transactionReference: "",
                            cashierId: "",
                          };
                          handleOnSubmit(data);
                        }}
                      >
                        Next
                      </Button>
                    )
                  ) : (
                    <Button variant="contained" type="submit" color="primary">
                      Next
                    </Button>
                  )}
                </DialogActions>
              </Form>
            </>
          )}
        </Formik>
      </Dialog>
    </>
  );
};

export default OrderGrid;

const getStatusChip = (status: string) => {
  if (status === "Finalized")
    return <Chip label={status} color="success" size="small" />;
  else if (status === "Committed")
    return <Chip label={status} color="warning" size="small" />;
  else if (status === "Archived")
    return <Chip label="Archived" color="error" size="small" />;
  else return <Chip label="Unknown" color="error" size="small" />;
};
const getWarrantyChip = (warranty: boolean) => {
  if (warranty) return <Chip label="Yes" color="success" size="small" />;
  else return <Chip label="No" color="warning" size="small" />;
};
export const searchOptions = {
  types: ["address"],
};
